exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-brand {\n  float: right; }\n\n.edit-text {\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  height: 2.5rem; }\n\n.edit-button {\n  height: 2.5rem;\n  line-height: 0 !important;\n  margin-left: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/suggestions/detail-dialog/detail-dialog.component.scss
// module id = ../../../../../src/app/main/content/suggestions/detail-dialog/detail-dialog.component.scss
// module chunks = main